import isNode from 'lib/is-node'

export const isPWA =
  !isNode && window.matchMedia('(display-mode: minimal-ui)').matches

// const _blank = isPWA ? '_self' : '_blank'
//
// export default _blank
